import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Search } from "@mui/icons-material";
import { FilterForm } from "../../components/FiltersForm/FiltersForm";
import { Skeleton } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import axios from "axios";
import {
  CircularProgress,
  Typography,
  Box,
  TextField,
  IconButton,
} from "@mui/material";
import { URL } from "../../constants/constant";
import { Button } from "@mui/material";
import moment from "moment";

export function DashboardTab({ tabName, currentToggle }) {
  const [corporateRows, setCorporateRows] = useState("");
  const [columns, setColumns] = useState([]);
  const [page, setPage] = useState(0);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterOptionsLoading, setIsFilterOptionsLoading] = useState(true);
  const [errorSnackBarOpen, setErrorSnackBarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState("");
  const handleChangeInitialDate = (newValue) => {
    setValueFrom(newValue);
  };

  const handleChangeFinalDate = (newValue) => {
    setValueTo(newValue);
  };
  //temporary values
  const [valueFrom, setValueFrom] = useState(
    moment().subtract(1, "days")
  );
  const [valueTo, setValueTo] = useState(moment());

  const [filterOptions, setFilterOptions] = useState({});

  const getNewFilters = (oldFilters, selectedFilters) => {
    const newStateFilterOptions = [];
    const newStateIds = selectedFilters.map((item) => item.id);
    for (let j = 0; j < oldFilters.length; j++) {
      const newStateFilterItem = {
        text: oldFilters[j].text,
        id: oldFilters[j].id,
        selected: true,
      };
      if (!newStateIds.includes(oldFilters[j].id)) {
        newStateFilterItem.selected = false;
      }
      newStateFilterOptions.push(newStateFilterItem);
    }

    return newStateFilterOptions;
  };

  const fetchFilterOptions = async (forceBlankFilters = false) => {
    setIsFilterOptionsLoading(true);
    const res = await axios
      .post(URL.demystify_url + "dashboard/fetchFilters", {
        currentTab: tabName,
        currentToggle: currentToggle,
        currentFilterOptions:
          Object.keys(filterOptions).length && !forceBlankFilters
            ? filterOptions
            : undefined,
      })
      .catch((err) => {
        setError(err);
      });
    //setFilterOptions({ ...fetchFilterOptions });
    setIsFilterOptionsLoading(false);
    if (res && res.data) {
      console.log(res.data);
      if (res.data.message) {
        if (res.data.message.currentFilterOptions) {
          setFilterOptions(res.data.message.currentFilterOptions);
          return;
        } else {
          setFilterOptions(res.data.message);
          return;
        }
      }
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchFilterOptions(true).then(() => {
      getAndSetTableData();
    });
  }, [currentToggle, tabName]);

  useEffect(() => {
    if (corporateRows.length) {
      const firstRow = corporateRows[0];
      const colum_headers = Object.keys(firstRow).filter((key) => key !== "id");
      const columns = colum_headers.map((key) => {
        return {
          field: key,
          headerName: key,
          headerAlign: "center",
          headerClassName: "header-text",
          flex: 1,
          minWidth: 150,
        };
      });
      setColumns(columns);
    }
  }, [corporateRows]);

  const getAndSetTableData = async () => {
    setIsLoading(true);
    const dateFrom = new Date(valueFrom.toDate().getTime() + 330*60000);
    const dateTo = new Date(valueTo.toDate().getTime() + 330*60000);
    var config = {
      method: "post",
      url: URL.demystify_url + "dashboard/dashboardData",
      data: {
        currentTab: tabName,
        currentToggle: currentToggle,
        currentFilterOptions: filterOptions,
        dateFrom: dateFrom,
        dateTo: dateTo,
      },
    };
    console.log(config)
    axios(config)
      .then(function (response) {
        const results = response.data.message;
        //add an id to each row
        for (let i = 0; i < results.length; i++) {
          results[i].id = "fallback_" + i.toString();
        }
        setCorporateRows(results);
        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);
        setCorporateRows([]);
        try {
          const errorMessage = error.response.data.message;
          setSnackbarErrorMessage(
            "Error fetching rows for current filters : " +
            errorMessage.toString()
          );
          setErrorSnackBarOpen(true);
        } catch (error) {
          alert("Unknown error occured");
        }
        //alert("Error fetching rows for current filters")
      });
  };

  return (
    <>
      <div style={{ width: `90vw` }}>
        {
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "5%",
              paddingBottom: "15px",
              justifyContent: "flex-start",
              alignItems: "end",
            }}
          >
            {Object.keys(filterOptions).map((key) => {
              return (
                <FilterForm
                  filterOptionsTitle={key}
                  filterOptions={filterOptions[key]}
                  key={key}
                  onChangeCallback={(newStateOptions) => {
                    const newStateFilterOptions = getNewFilters(
                      [...filterOptions[key]],
                      newStateOptions
                    );
                    setFilterOptions({
                      ...filterOptions,
                      [key]: newStateFilterOptions,
                    });
                  }}
                  onCloseCallback={(e) => {
                    fetchFilterOptions();
                  }}
                  suspend={isFilterOptionsLoading}
                />
              );
            })}
            {isFilterOptionsLoading ? (
              <></>
            ) : (
              <Box
                display={"flex"}
                gap={"1%"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                marginBottom
                marginTop={"30px"}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    label="From"
                    inputFormat="DD/MM/YYYY HH:mm"
                    value={valueFrom}
                    onChange={handleChangeInitialDate}
                    renderInput={(params) => (
                      <TextField variant="filled" size="small" {...params} />
                    )}
                  />
                  <Typography>to</Typography>
                  <DateTimePicker
                    label="To"
                    inputFormat="DD/MM/YYYY HH:mm"
                    value={valueTo}
                    onChange={handleChangeFinalDate}
                    renderInput={(params) => (
                      <TextField variant="filled" size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
                <Button
                  style={{
                    width: "200px",
                    border: "1px solid black",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "end  ",
                    margin: "10px",
                  }}
                  onClick={() => getAndSetTableData()}
                >
                  Apply filters
                  <Search />
                </Button>
              </Box>
            )}
          </div>
        }
        {isLoading ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <div>
            <div
              style={{
                height: "100%",
                paddingBottom: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <DataGrid
                autoWidth
                autoHeight
                autoPageSize
                rows={corporateRows}
                getRowId={(row) => row.entity || row.id}
                columns={columns}
                pageSize={10}
                //rowsPerPageOptions={[10, 20, 50, 100]}
                pagination
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                components={{ Toolbar: GridToolbar }}
                sx={{
                  width: "100%",
                  overflowX: "auto",
                  border: 1,
                  "& .MuiDataGrid-cell:hover": {
                    cursor: "pointer",
                  },
                  "& .MuiDataGrid-cell": {
                    borderRight: 0.5,
                    borderTop: 0.5,
                    justifyContent: "center",

                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#3275a8",
                    color: "white",
                    fontSize: 16,
                  },
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
            </div>
          </div>
        )}
      </div>
      <Snackbar
        open={errorSnackBarOpen}
        autoHideDuration={3000}
        onClose={() => setErrorSnackBarOpen(false)}
        message={snackbarErrorMessage}
      />
    </>
  );
}
